import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationsStaffRolesInfo: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATIONS_STAFF_ROLES_INFO].GET_REGULATIONS_STAFF_ROLES_INFO,
	},
}